/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { Opinion } from '../model/opinion';
import { OpinionNew } from '../model/opinionNew';
import { TipoDestinoDeOpinion } from '../model/tipoDestinoDeOpinion';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiOpinionesService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Elimina una opinion de un usuario sobre un destino.
     * Elimina una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling deleteKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lee una opinion de un usuario sobre un destino.
     * Lee una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Opinion>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Opinion>>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Opinion>>;
    public getKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling getKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling getKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Opinion>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una opinion de un usuario sobre un destino.
     * Crea una opinion de un usuario sobre un destino.
     * @param usuario El usuario de kogui.
     * @param tipoDestino El usuario de kogui.
     * @param destino El id del destino.
     * @param opinionNew Opinion Request
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Opinion>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Opinion>>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Opinion>>;
    public putKoguiByUsuarioByDestino(usuario: string, tipoDestino: TipoDestinoDeOpinion, destino: string, opinionNew: OpinionNew, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (tipoDestino === null || tipoDestino === undefined) {
            throw new Error('Required parameter tipoDestino was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (destino === null || destino === undefined) {
            throw new Error('Required parameter destino was null or undefined when calling putKoguiByUsuarioByDestino.');
        }
        if (opinionNew === null || opinionNew === undefined) {
            throw new Error('Required parameter opinionNew was null or undefined when calling putKoguiByUsuarioByDestino.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Opinion>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/opiniones/${encodeURIComponent(String(tipoDestino))}/${encodeURIComponent(String(destino))}`,
            opinionNew,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
